import { Button, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { PhotoEvent } from 'common-models';
import { FC, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSiteTitle } from 'src/context/SiteTitleContext';
import EventBrowser from './EventBrowser';
import { EventEditorView as EventEditor } from './EventEditorView';



const EventAdminView: FC<any> = () => {

    const theme = useTheme();
    const params = useParams();
    const eventId = params.eventId as string;

    const siteTitle = useSiteTitle();
    useEffect(() => {

        document.title = `${siteTitle.title} - Event administration`;

        window.scrollTo(0, 0);

        if (eventId === undefined) {
            setEventToEdit(undefined as unknown as PhotoEvent);
        }
        else if (eventId.toLowerCase() === 'new') {
            const now = new Date();
            setEventToEdit({
                id: 'new',
                title: '',
                isExternalCopyright: false,
                eventStartTime: now,
                eventEndTime: now,
                isPublic: true,
                displayFreeOfChargeText: true,
                isFreeOfCharge: false,
            });
        }

    }, [eventId, siteTitle.title]);

    const [eventToEdit, setEventToEdit] = useState(undefined as unknown as PhotoEvent);

    const cancelEventEditing = () => {
        setEventToEdit(undefined as unknown as PhotoEvent);
    };

    return (
        <>
            {
                eventToEdit === undefined
                    ? <>
                        <Typography
                            component="nav"
                            sx={{
                                mb: 2,
                                '& a': {
                                    color: theme.palette.text.primary,
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    }
                                }
                            }}
                        >
                            <Link to={`/admin/events/new`}>
                                Add new event
                            </Link>
                            <span style={{ margin: '0 8px', color: theme.palette.text.secondary }}> | </span>
                            <Link to={`/admin/events/pricelists`}>
                                Edit price lists
                            </Link>
                        </Typography>
                        <Grid container>
                            <Grid size="auto">
                                <EventBrowser />
                            </Grid>
                        </Grid>
                    </>
                    : <>
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                            <Grid size="auto">
                                <Button
                                    variant='outlined'
                                    onClick={cancelEventEditing}
                                    sx={{
                                        color: theme.palette.text.primary,
                                        borderColor: theme.palette.text.primary,
                                        '&:hover': {
                                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                            borderColor: theme.palette.text.primary,
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid size="auto">
                                <Button
                                    variant='contained'
                                    onClick={cancelEventEditing}
                                    sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        color: theme.palette.mode === 'dark' ? theme.palette.text.primary : '#fff',
                                        '&:hover': {
                                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.dark || '#7b1fa2' : theme.palette.primary.dark || '#666',
                                        }
                                    }}
                                >
                                    Save & close
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid size="auto">
                                <EventEditor />
                            </Grid>
                        </Grid>
                    </>
            }

        </>
    )
    // }
}

export default EventAdminView;
